var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-component message-block error"},[_c('strong',[_vm._v("Error")]),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }